import { AddBox, IndeterminateCheckBox } from "@mui/icons-material";
import { Stack, Box, Button, Typography, IconButton } from "@mui/material";
import React from "react";

function IncrementDecrement({ canEdit, amount, onIncrement, onDecrement }) {
  return (
    <Box
      style={{
        placeSelf: "center",
      }}
    >
      <Stack direction={"row"} spacing={1}>
        {canEdit && (
          <IconButton disabled={!canEdit} color="primary" onClick={onIncrement}>
            <AddBox />
          </IconButton>
        )}
        <Typography alignSelf={"center"}>{amount}</Typography>
        {canEdit && (
          <IconButton disabled={!canEdit} color="primary" onClick={onDecrement}>
            <IndeterminateCheckBox />
          </IconButton>
        )}
      </Stack>
    </Box>
  );
}

export default IncrementDecrement;
